module.exports = __webpack_public_path__ + "static/media/grin-wink.aa008441.svg";